import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AppService } from 'src/app/service/app.service';
import { UserDetailsService } from 'src/app/service/user-details.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  user: any = {};

  constructor(private appService: AppService,
    private userDetailsService: UserDetailsService,
    private router: Router) { }

  ngOnInit(): void {
    this.userDetailsService.getUserDetailsDashboard().pipe(
      catchError((error: any) => {
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.userDetailsService.setUserDetails(response.data && response.data[0]);
        this.user = response.data[0];
      }
    });
  }

  changePassword() {
    this.router.navigate(['/changepassword'], { queryParams: { 'page': 'home', 'username': this.user?.loginId } })
  }

  profile() {
    this.router.navigate(['/profile']);
  }

  settings(){
    this.router.navigate(['/settings']);
  }

  logout() {
    this.appService.logout(this.user).pipe(
      catchError((error: any) => {
        localStorage.removeItem('token');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('username');
        this.router.navigate(['/login']);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
        localStorage.removeItem('token');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('username');
        this.router.navigate(['/login']);
    });
  }
}
